import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeIcon, RefreshCwIcon, ShieldIcon, ClockIcon, AwardIcon } from 'lucide-react';
import { Logo } from '../components/Logo';
export function Home() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center" data-id="element-202">
      {/* Dark Hero Section */}
      <div className="w-full bg-slate-900 flex flex-col items-center px-4 pt-12 pb-24" data-id="element-203">
        <div className="w-full max-w-6xl" data-id="element-204">
          <div className="flex justify-center mb-16" data-id="element-205">
            <Logo size="lg" variant="light" data-id="element-206" />
          </div>

          <div className="text-center mb-16" data-id="element-207">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800/50 border border-slate-700 text-sm text-slate-300 mb-8" data-id="element-208">
              <span className="w-2 h-2 rounded-full bg-blue-400" data-id="element-209"></span>
              NMLS #2148818 · Licensed in 16 States
            </div>

            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-210">
              Mortgages <br data-id="element-211" />
              <span className="text-blue-400" data-id="element-212">Done Better</span>
            </h1>
            <p className="text-xl text-slate-300 max-w-2xl mx-auto mb-12" data-id="element-213">
              Expert mortgage solutions with competitive rates. Let us guide you
              through every step of the home financing process.
            </p>

            <div className="flex flex-wrap justify-center gap-6 text-left" data-id="element-214">
              <div className="flex items-center gap-3 bg-slate-800/50 px-6 py-4 rounded-xl border border-slate-700" data-id="element-215">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-blue-400 border border-slate-700" data-id="element-216">
                  <ShieldIcon className="w-5 h-5" data-id="element-217" />
                </div>
                <div data-id="element-218">
                  <div className="font-bold text-white" data-id="element-219">Trusted</div>
                  <div className="text-sm text-slate-400" data-id="element-220">Since 2021</div>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-slate-800/50 px-6 py-4 rounded-xl border border-slate-700" data-id="element-221">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-blue-400 border border-slate-700" data-id="element-222">
                  <ClockIcon className="w-5 h-5" data-id="element-223" />
                </div>
                <div data-id="element-224">
                  <div className="font-bold text-white" data-id="element-225">Avg. Close</div>
                  <div className="text-sm text-slate-400" data-id="element-226">As Fast as 11 Days*</div>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-slate-800/50 px-6 py-4 rounded-xl border border-slate-700" data-id="element-227">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-blue-400 border border-slate-700" data-id="element-228">
                  <AwardIcon className="w-5 h-5" data-id="element-229" />
                </div>
                <div data-id="element-230">
                  <div className="font-bold text-white" data-id="element-231">2,000+</div>
                  <div className="text-sm text-slate-400" data-id="element-232">Families Served</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Light Cards Section */}
      <div className="w-full max-w-6xl px-4 -mt-12 pb-16" data-id="element-233">
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-234">
          <button onClick={() => navigate('/purchase')} className="group bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-blue-600 hover:shadow-xl transition-all duration-200 text-left" data-id="element-235">
            <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors" data-id="element-236">
              <HomeIcon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors" data-id="element-237" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-238">
              Purchase Application
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-239">
              Apply for a mortgage to purchase a new home. Complete our
              streamlined application process.
            </p>
            <div className="flex items-center text-blue-600 font-medium group-hover:gap-2 transition-all" data-id="element-240">
              Start Application
              <span className="ml-2 group-hover:ml-0 transition-all" data-id="element-241">→</span>
            </div>
          </button>

          <button onClick={() => navigate('/refinance')} className="group bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-blue-600 hover:shadow-xl transition-all duration-200 text-left" data-id="element-242">
            <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors" data-id="element-243">
              <RefreshCwIcon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors" data-id="element-244" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-245">
              Refinance Application
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-246">
              Refinance your existing mortgage to get better rates or terms.
              Quick and easy process.
            </p>
            <div className="flex items-center text-blue-600 font-medium group-hover:gap-2 transition-all" data-id="element-247">
              Start Application
              <span className="ml-2 group-hover:ml-0 transition-all" data-id="element-248">→</span>
            </div>
          </button>
        </div>
      </div>
    </div>;
}